<template>
    <div class="login-wrap" v-loading="loadStatus" element-loading-text="正在登陆中...">
        <Header />
        <img src="../../assets/img/common/logoleft.jpg" alt="" class="leftImg">
        <div class="ms-login-bg"></div>
        <div class="ms-login">
            <ul class="ms-header">
                <li :class="{'active':i==index}" v-for="(v,i) in ['账号登陆','短信登陆']" @click="liChange(i)">{{v}}</li>
            </ul>
            <el-form class="ms-content" ref="loginrule" label-width="0px" :model="form" :rules="rules">
                <div v-if="index == 0">
                    <el-form-item prop="username">
                        <el-input v-model="form.username" placeholder="账号名/邮箱/手机号">
                            <i slot="prepend" class="iconfont icon-yonghu1"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" placeholder="请输入登陆密码" v-model="form.password" @keyup.enter.native="toLogin()">
                            <i slot="prepend" class="iconfont icon-mima"></i>
                        </el-input>
                    </el-form-item>
                </div>
                <div v-if="index == 1">
                    <el-form-item prop="phone">
                        <el-input v-model="form.phone" placeholder="请输入手机号">
                            <i slot="prepend" class="iconfont icon-shouji1"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="code" v-if="index == 1" class="code">
                        <el-input v-model="form.code" placeholder="请输入验证码">
                            <i slot="prepend" class="iconfont icon-icon"></i>
                        </el-input>
                        <span @click="getCode" v-if="count == 0">获取验证码</span>
                        <span v-else>{{count}}秒后重发</span>
                    </el-form-item>
                </div>
                <el-form-item class="login-btn">
                    <el-button type="primary" @click="toLogin()">登录</el-button>
                </el-form-item>
                <div class="login-other" @click="toOtherLogin">
                    <i class="iconfont icon-gangweiquanxian"></i>
                    <span>统一平台授权登陆</span>
                </div>
                <ul class="other-links">
                    <li @click="jumpPage('/register')">免费注册</li>
                    <li v-if="index == 0" @click="jumpPage('/resetPassword')">忘记密码？</li>
                </ul>
            </el-form>
        </div>
        <Bottom />
    </div>
</template>

<script>
import mainApi from "network/mainApi";
import { mapMutations } from 'vuex'
import Header from "./components/header"
import Bottom from "./components/bottom"
export default {
    components: {
        Header,
        Bottom
    },
    data() {
        return {
            index: 0,
            appid: '',
            count: "",
            form: {
                username: "",
                password: "",
                phone: "",
                code: "",
            },
            rules: {
                username: [
                    { required: true, message: "账号名/邮箱/手机号", trigger: "blur" },
                ],
                password: [
                    { required: true, message: "请输入登陆密码", trigger: "blur" },
                ],
                phone: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                ],
                code: [
                    { required: true, message: "请输入验证码", trigger: "blur" },
                ],
            },
            loadStatus: false, //请求时的loading效果
        };
    },
    mounted() {
        // 获取威胁情报平台对应的appid
        this.getAppid()
    },
    methods: {
        ...mapMutations(['setState']),
        getAppid() {
            mainApi.getAppid().then(res => {
                if (res.data.code == 200) {
                    this.appid = res.data.data[1].appId;
                } else {
                    this.$message('获取appid失败')
                }
            }).catch((err) => {
                console.log(err);
            })
        },
        toLogin() {
            this.$refs.loginrule.validate((valid) => {
                if (valid) {
                    this.loadStatus = true;
                    if (this.index) {
                        this.codeLogin()
                    } else {
                        this.passLogin()
                    }


                }
            });
        },
        codeLogin() {
            mainApi
                .loginSms({ phone: this.form.phone, code: this.form.code })
                .then((res) => {
                    this.loadStatus = false;
                    let { code, data, msg } = res.data;
                    if (code == 200) {
                        localStorage.setItem(
                            "token",
                            data.access_token
                        );
                        localStorage.setItem(
                            "userInfo",
                            JSON.stringify(data)
                        );

                        this.$store.commit("setIsLogin", "true");
                        this.$message.success("登录成功");
                        setTimeout(
                            this.$router.push({ path: "/home" }), //通过this.$router访问路由实例，调用push方法可以导航到不同的URL中。
                            500
                        );
                    } else {
                        this.$message.error(msg);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });

        },
        passLogin() {
            let params = {
                username: this.form.username,
                password: this.form.password,
            };
            mainApi
                .login(params)
                .then((res) => {
                    this.loadStatus = false;
                    let { code, data, msg } = res.data;
                    if (code == 200) {
                        localStorage.setItem(
                            "token",
                            data.access_token
                        );
                        localStorage.setItem(
                            "userInfo",
                            JSON.stringify(data)
                        );

                        this.$store.commit("setIsLogin", "true");
                        this.$message.success("登录成功");
                        setTimeout(
                            this.$router.push({ path: "/home" }), //通过this.$router访问路由实例，调用push方法可以导航到不同的URL中。
                            500
                        );
                    } else {
                        this.$message.error(msg);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        // 第三方登录
        async toOtherLogin() {
            if (!this.appid) {
                await this.getAppid()
            }
            mainApi.otherLogin({ appId: this.appid }).then((res) => {
                let { code, data, msg } = res.data;
                if (code == 302) {
                    localStorage.setItem('state', data.stateCode)
                    // const appid = data.callbackUrl.split("&")[0].split("=")[1]
                    // const appSecret = data.callbackUrl.split("&")[1].split("=")[1]
                    // const redirect_uri = data.callbackUrl.split("&")[2].split("=")[1]
                    // const url = `http://172.27.200.191:8082/unify/dist/connect/qrconnect?appId=${appid}&redirect_uri=${redirect_uri}&appSecret=${appSecret}`
                    // console.log(url);
                    // window.open(url, "_self");
                    window.open(data.callbackUrl, "_self")
                }
            });
        },
        // 切换登陆方式
        liChange(i) {
            this.index = i;
            // this.$refs.loginrule.resetFields()
        },
        // 获取验证码
        getCode() {
            if (!this.form.phone) return
            mainApi
                .getCode({ phone: this.form.phone })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.$message('验证码已发送')
                    }
                })
                .catch((error) => {
                    console.log(error);
                });

            let time_count = 60; //60秒
            if (!this.timer) {
                this.count = time_count;
                this.timer = setInterval(res => {
                    if (this.count > 0 && this.count <= time_count) {
                        this.count--;
                    } else {
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }

        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        jumpPage(url) {
            this.$router.push(url)
        }

    },
};
</script>

<style scoped lang='scss'>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/img/common/bg1.jpg);
    background-size: 100% 100%;
    .leftImg {
        position: absolute;
        top: 50%;
        left: 10%;
        transform: translate(0, -50%);
        /* box-shadow: 0px 0px 80px 0px #08273c; */
    }
    .ms-login-bg,
    .ms-login {
        position: absolute;
        right: 10%;
        top: 50%;
        width: 350px;
        height: 320px;
        border-radius: 4px;
        transform: translateY(-50%);
    }
    .ms-login {
        background: rgba(255, 255, 255, 0.9);
        .ms-header {
            display: flex;
            width: 100%;
            line-height: 30px;
            height: 60px;
            padding: 15px 0;
            box-sizing: border-box;
            li {
                flex: 1;
                font-size: 16px;
                color: #3c3c3c;
                text-align: center;
                cursor: pointer;
                &:last-child {
                    border-left: 2px solid #cdcfcf;
                }
            }
            .active {
                font-weight: bolder;
            }
        }
        .ms-content {
            padding: 0px 30px 0px 30px;
            /deep/ .el-form-item {
                margin-bottom: 20px;
                .iconfont {
                    font-size: 20px;
                }
                .el-input__inner {
                    height: 42px;
                    line-height: 42px;
                    padding-right: 90px;
                    &::-webkit-input-placeholder {
                        /* placeholder颜色 */
                        color: #aab2bd;
                        /* placeholder字体大小 */
                        font-size: 13px;
                    }
                }
                .el-input-group__prepend {
                    width: 42px;
                    padding: 0;
                    text-align: center;
                }
            }
            .code {
                position: relative;
                span {
                    position: absolute;
                    line-height: 42px;
                    right: 0;
                    top: 0;
                    padding: 0 10px;
                    cursor: pointer;
                }
            }
            .login-btn {
                button {
                    width: 100%;
                    height: 38px;
                    font-size: 16px;
                }
            }
            /* 统一登陆样式 */
            .login-other {
                font-size: 13px;
                height: 30px;
                display: flex;
                align-items: center;
                color: #6c6c6c;
                i {
                    font-size: 30px;
                    color: #eb7644;
                    margin-right: 10px;
                }
            }
            .other-links {
                display: flex;
                font-size: 12px;
                color: #6c6c6c;
                line-height: 50px;
                justify-content: flex-end;
                li {
                    padding-left: 10px;
                    cursor: pointer;
                }
            }
        }
    }
    @media screen and (max-width: 900px) {
        .ms-login {
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            transform: translateY(0);
        }
    }
}
</style>
